import Vue from 'vue'
// 语音播放
import audio from '@/utils/audio'

Vue.prototype.audio = audio
